import Vue from 'vue'
// import router from '@/router/index.js'

export default {
  email: '',
  password: '',
  check () {
    let checkAutenticated = 'success'
    let checkAutenticatedBackend = true
    let token = JSON.parse(sessionStorage.getItem('token'))

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('token')) {
        if (checkAutenticated === 'success' && token.access_token && token.token_type) {
          checkAutenticatedBackend = false
          Vue.http.get(
            'api/oauth/user/check',
            {
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': token.token_type + ' ' + token.access_token
              }
            }
          ).then((response) => {
            resolve({
              status: 'success',
              data: response.data
            })
          }, response => {
            resolve({
              status: 'error',
              data: 'No tiene permisos para acceder a este recurso.'
            })
          })
          // resolve({
          //   status: checkAutenticated,
          //   data: 'Validando en el backend.'
          // })
        } else {
          checkAutenticated = 'error'
        }
      } else {
        checkAutenticated = 'error'
      }

      if (checkAutenticated === 'error' && checkAutenticatedBackend === true) {
        resolve({
          status: checkAutenticated,
          data: 'No tiene permisos para acceder a este recurso.'
        })
      }
    })
  },
  signin () {
    return new Promise((resolve, reject) => {
      Vue.http.post(
        'api/oauth/token',
        {
          grant_type: 'password',
          client_id: 1,
          client_secret: 'K0JiA9TdF6DJkQl27m5vTkDTuovEvu3lqqfXbMZ9',
          username: this.email,
          password: this.password
        }
      ).then((response) => {
        resolve({
          status: 'success',
          data: response.data
        })
      }, response => {
        resolve({
          status: 'error',
          data: response.data
        })
      })
    })
  },
  signout () {
    let token = JSON.parse(sessionStorage.getItem('token'))
    return new Promise((resolve, reject) => {
      Vue.http.get(
        'api/oauth/user/logout',
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': token.token_type + ' ' + token.access_token
          }
        }
      ).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/auth.js